/**
 * Shared LYW brand styling for unit / lesson cards on Plan tabs.
 * Palette: see packages/app/brandPalette.cjs (official LYW hex values).
 */

/** Highlight blue — unit card shell (replaces mid-gray mockup background). */
export const unitCardShellClass =
    'overflow-hidden border border-gray-400/70 !bg-edgewater shadow-sm';

export const unitCardHeaderClass =
    'w-full cursor-pointer px-6 py-4 text-left transition-colors !bg-edgewater hover:!bg-monte-carlo/40';

/** Expand/collapse titles styled as links so the click target is obvious without relying on the pointer. */
export const unitCardExpandableTitleClass = 'underline underline-offset-2 decoration-current';

export const unitCardBodyClass = 'border-t border-gray-400/60 !bg-edgewater';

export const unitCardBodyMetaClass = 'mb-6 flex flex-wrap items-center gap-3 text-sm text-gray-600';

/** Solid topic chips — dark green (closest brand match: silver-tree depth via green-800). */
export const unitTopicBadgeClass =
    'max-w-full whitespace-normal break-words text-left rounded-md border-0 bg-silver-tree px-2.5 py-0.5 text-sm font-normal leading-snug text-white shadow-none hover:bg-silver-tree';

export const unitTopicsFieldsetClass =
    'min-w-0 rounded-lg border border-gray-300/90 bg-gray-100/90 px-3 pb-2 pl-7 pt-3 tracking-wide';

export const unitTopicsLegendClass =
    'mb-1.5 font-sans text-xs font-medium leading-none text-gray-600';
